document.addEventListener("DOMContentLoaded", () => {
  // Select the Vimeo embed container
  const vimeoEmbedContainer = document.querySelector(".vimeo-embed") as HTMLElement;
  const vimeoHeading = document.querySelector(".vimeo-heading") as HTMLElement;
  const vimeoIframe = vimeoEmbedContainer?.querySelector("iframe") as HTMLIFrameElement;

  if (vimeoEmbedContainer && vimeoIframe) {
    // Function to set the height dynamically
    const resizeVimeoEmbed = (): void => {
      const containerWidth: number = vimeoEmbedContainer.offsetWidth; // Get the current width of the container
      const headingHeight: number = vimeoHeading ? vimeoHeading.offsetHeight : 0; // Get the dynamic height of the heading or 0 if not present
      const videoHeight: number = containerWidth * (9 / 16); // Calculate video height based on 16:9 ratio
      const totalHeight: number = headingHeight + videoHeight; // Total height is heading height + video height

      if (vimeoHeading) {
        // If heading is present
        vimeoEmbedContainer.style.height = `${totalHeight}px`; // Set the container height dynamically
        vimeoIframe.style.height = `${videoHeight}px`; // Set the video height dynamically
        vimeoIframe.style.top = `${headingHeight}px`; // Position the iframe just below the heading
      } else {
        // If heading is not present
        vimeoEmbedContainer.style.height = `${videoHeight}px`; // Set the container height to just the video height
        vimeoIframe.style.height = "100%"; // Make iframe full height
        vimeoIframe.style.top = "0"; // Position the iframe at the top
      }
    };

    // Call the function on load
    resizeVimeoEmbed();

    // Adjust the container height on window resize
    window.addEventListener("resize", resizeVimeoEmbed);
  }
});
